






















import Vue from "vue";
import BlankoComp from "../../components/blanko/BlankoComp.vue";
import _gamedata from "../../services/endpoints/gamedata";
import _blankos from "../../services/endpoints/blankos";
import BlankoMenuWingComp from "../../components/blanko/BlankoMenuWingComp.vue";
import { Encounter } from "../../../../models/Encounter";
import { blankoElement, userRaid } from "models/Types";
import { wingStrike } from "../../../../models/Types";

export default Vue.extend({
	name: "BlankoPage",
	components: { BlankoMenuWingComp, BlankoComp },
	data: () => ({
		wingFilter: null as wingStrike,
		elements: null as blankoElement[],
		bosses: [] as Encounter[],
	}),
	computed: {
		filteredBosses: function(): Encounter[] {
			if (!this.wingFilter || this.wingFilter.id === 0) {
				return this.bosses;
			}

			if (!this.wingFilter.isStrike) {
				return this.bosses.filter(b => b.wing === this.wingFilter.id);
			}
			else {
				return this.bosses.filter(b => b.strike === this.wingFilter.id);
			}
		},
		raid: function(): userRaid {
			return this.$vStore.getters.raid;
		},
		role: function(): number {
			return this.$vStore.getters.raidRole;
		},
	},
	methods: {
		pick: async function(wing: wingStrike): Promise<void> {
			this.wingFilter = wing;
		},
		copyBlanko: async function(info: number[]): Promise<void> {
			this.elements = await _blankos.copyFromTo(this.raid.id, info[0], info[1]);
		},
	},
	created: async function(): Promise<void> {
		this.elements = await _blankos.getAllElements(this.raid.id);
		this.bosses = await _gamedata.listEncounter();
	},
});
